import type { History } from 'history';
import * as React from 'react';
import type { RouteComponentProps } from 'react-router';

interface Options {
  redirect: string;
}

export function requireAuthenticationFactory<T extends Options>(
  checkUser: (history: History, options?: T) => void
) {
  return (Component: React.ComponentType<object>, options?: T) => {
    type Props = RouteComponentProps;

    class AuthComponent extends React.Component<Props> {
      // Authentication must run before protected descendants mount and start side effects.
      // oxlint-disable-next-line react/no-unsafe
      UNSAFE_componentWillMount() {
        checkUser(this.props.history, options);
      }

      // Authentication must run before protected descendants receive updated route props.
      // oxlint-disable-next-line react/no-unsafe
      UNSAFE_componentWillReceiveProps(nextProps: Props) {
        checkUser(nextProps.history, options);
      }

      render() {
        return <Component {...this.props} />;
      }
    }
    return AuthComponent;
  };
}
